// Minimalist editorial table. columns: [str], rows: [[str,...]]
export const ComparisonTable = ({ columns = [], rows = [] }) => (
  <div className="overflow-x-auto rounded-2xl border border-stone-line bg-white" data-testid="comparison-table">
    <table className="w-full text-left border-collapse">
      <thead>
        <tr className="border-b border-stone-line bg-sand/60">
          {columns.map((col, i) => (
            <th
              key={i}
              className="px-5 py-4 font-sans text-xs font-semibold uppercase tracking-[0.12em] text-charcoal md:px-7"
            >
              {col}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {rows.map((row, ri) => (
          <tr
            key={ri}
            className="border-b border-stone-line last:border-0 transition-colors hover:bg-sand/40"
          >
            {row.map((cell, ci) => (
              <td
                key={ci}
                className={`px-5 py-4 md:px-7 ${
                  ci === 0
                    ? "font-medium text-charcoal"
                    : "font-light text-slatey"
                }`}
              >
                {cell}
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);

export default ComparisonTable;
